import React from 'react';
import { useState } from 'react'
import { CheckIcon } from '@heroicons/react/20/solid'
import { NavLink } from 'react-router-dom';

const frequencies = [
  { value: 'monthly', label: 'Monthly', priceSuffix: '' },
  { value: 'annually', label: 'Annually', priceSuffix: '' },
]

const tiers = [
  {
    name: 'Basic',
    id: 'basic-camp',
    href: '/register?package=basic',
    price: { monthly: '$250', annually: '$250' },
    description: 'Enjoy our camp for during our regular camp hours.',
    features: [
      'Dec 27 - 29th', 
      '9:00AM - 3:00PM', 
      '1 on 1 Technical training with a focus on dribbling, shooting, and passing', 
      'Small sided games/tournaments',
      'Camp vs Counselor Games',
      'Other Fun Activities'
    ],
    mostPopular: false,
  },
  {
    name: 'Before-Care',
    id: 'before-care',
    href: '/register',
    price: { monthly: '$300', annually: '$300' },
    description: 'Drop your child off early with our before-care hours.',
    features: [
      'Dec 27 - 29th', 
      '7:00AM - 3:00PM', 
      '1 on 1 Technical training with a focus on dribbling, shooting, and passing', 
      'Small sided games/tournaments',
      'Camp vs Counselor Games',
      'Other Fun Activities'
    ],
    mostPopular: false,
  },
  {
    name: 'After-Care',
    id: 'after-care',
    href: '/register?package=after-care',
    price: { monthly: '$300', annually: '$300' },
    description: 'Pick your child up late with our after-care camp hours.',
    features: [
      'Dec 27 - 29th', 
      '9:00AM - 5:00PM', 
      '1 on 1 Technical training with a focus on dribbling, shooting, and passing', 
      'Small sided games/tournaments',
      'Camp vs Counselor Games',
      'Other Fun Activities'
    ],
    mostPopular: true,
  },
  {
    name: 'Extended',
    id: 'extended',
    href: '/register?package=extended',
    price: { monthly: '$300', annually: '$300' },
    description: 'Drop your child off early and pick your child up late.',
    features: [
      'Dec 27 - 29th', 
      '7:00AM - 5:00PM', 
      '1 on 1 Technical training with a focus on dribbling, shooting, and passing', 
      'Small sided games/tournaments',
      'Camp vs Counselor Games',
      'Other Fun Activities'
    ],
    mostPopular: false,
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Pricing() {
  const [frequency] = useState(frequencies[0])

  return (
    <div id="pricing" className="container-padding mt-24 scroll-m-16">
      <div className="">
        
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="font-semibold text-primary-200 mb-3" id="pricing">Pricing</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight sm:text-5xl">
            Pricing plans for the SelectFut Camp
          </p>
          <p className="mx-auto mt-2 max-w-2xl text-center text-lg leading-8">
            Choose a camp plan that suits your schedule and let us take care of the rest!
          </p>
        </div>
        
        <div className="price-grid">
          {tiers.map((tier) => (
            <div
              key={tier.id}
              className={classNames(
                'empty-card px-8 py-10',
                tier.mostPopular ? 'most-popular text-white' : 'bg-white border-neutral-100 text-black',
                
              )}
            >
              <h2
                id={tier.id}
                className={classNames(
                  tier.mostPopular ? 'text-white' : 'text-black',
                  'leading-8'
                )}
              >
                {tier.name}
              </h2>
              <p className="mt-4 text-sm leading-6 flex-grow">{tier.description}</p>
              <p className="mt-6 flex items-baseline gap-x-1">
                <span className="text-4xl font-bold tracking-tight">{tier.price[frequency.value]}</span>
                <span className="text-4xl font-bold tracking-tight">{frequency.priceSuffix}</span>
              </p>
              <NavLink
                to={tier.href}
                aria-describedby={tier.id}
                className={classNames(
                  tier.mostPopular? 'btn-primary': 'btn-info',
                  'padded-md w-full rounded-md mt-4 block text-center'
                )}
              >
                Register
              </NavLink>
              <ul 
                role="list" 
                className={classNames(tier.mostPopular? "text-white" : "text-black" , "mt-8 space-y-3 text-sm leading-6")}
              >
                
                {tier.features.map((feature) => (
                  <li key={feature} className="flex gap-x-3">
                    <CheckIcon className="h-6 w-5 flex-none" aria-hidden="true" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
